import $ from 'jquery';
import 'slick-carousel';

jQuery(function($) {
    // Wait until all images are loaded
    $(window).on('load', function() {
        $('.banner-slider').each(function() {
            const $slider = $(this);

            // Read data attributes
            const autoplay = $slider.data('autoplay') === 'true';
            const delay = parseInt($slider.data('delay'), 10) || 4000;

            console.log('Initializing slider:', $slider, 'Autoplay:', autoplay, 'Delay:', delay);

            // Initialize Slick
            $slider.slick({
                autoplay: autoplay,
                autoplaySpeed: delay,
                arrows: true,
                dots: true,
                adaptiveHeight: true
            });
        });
    });

    $('.slider').each(function () {

        const slider2 = $(this);

        if (!slider2.hasClass('slick-initialized')) {

            slider2.slick({
               arrows: true,
                dots: true,
                autoplay: false,
                autoplaySpeed: 4000,

                slidesToShow: 3,
                slidesToScroll: 1,

                centerMode: true,
                centerPadding: '50px',

                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 2,
                            centerMode: true,
                            centerPadding: '0px'
                        }
                    },
                    {
                        breakpoint: 580,
                        settings: {
                            slidesToShow: 1,
                            centerMode: true,
                            centerPadding: '20px'
                        }
                    }
                ]
            });

        }

    });
});